document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('contactModal');
    const openBtn = document.getElementById('openContactModal');
    const closes = document.querySelectorAll('[data-close]');

    if (!openBtn || !modal) {
        console.error("Modal or button not found");
        return;
    }

    openBtn.addEventListener('click', e => {
        e.preventDefault();
        modal.classList.add('active');
    });

    closes.forEach(close => {
        close.addEventListener('click', () => modal.classList.remove('active'));
    });

    modal.addEventListener('click', e => {
        if (e.target.classList.contains('modal-overlay')) {
            modal.classList.remove('active');
        }
    });
});
